/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represent a phone number
 * @export
 * @interface PhoneNumber
 */
export interface PhoneNumber {
    /**
     * phone number without the Country-Code (but includes the Area-Code without 0)"
     * @type {string}
     * @memberof PhoneNumber
     */
    phoneNumber?: string;
    /**
     * phone number country prefix
     * @type {string}
     * @memberof PhoneNumber
     */
    phonePrefix?: string;
    /**
     * true if the number is a mobile
     * @type {boolean}
     * @memberof PhoneNumber
     */
    mobile?: boolean;
}

/**
 * Check if a given object implements the PhoneNumber interface.
 */
export function instanceOfPhoneNumber(value: object): value is PhoneNumber {
    return true;
}

export function PhoneNumberFromJSON(json: any): PhoneNumber {
    return PhoneNumberFromJSONTyped(json, false);
}

export function PhoneNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'phonePrefix': json['phonePrefix'] == null ? undefined : json['phonePrefix'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
    };
}

export function PhoneNumberToJSON(json: any): PhoneNumber {
    return PhoneNumberToJSONTyped(json, false);
}

export function PhoneNumberToJSONTyped(value?: PhoneNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phoneNumber': value['phoneNumber'],
        'phonePrefix': value['phonePrefix'],
        'mobile': value['mobile'],
    };
}

